import { useEffect, useState } from "react";
import {
  API_LEARNING_CREATE,
  apiGetLearningChallenge,
} from "../../utils/api-routes";
import { useApi } from "../use-api";
import { useSingleton } from "../use-singleton";
import { hasCourseAccess } from "./courses";
import { COOKIE_ACCESS_SUBSCRIBED_COURSES } from "../../utils/storage-constants";

export const useCommonDashboard = () => {
  const { get, post } = useApi();
  const { mail, role, examType } = useSingleton();
  const [learningRes, setLearningRes] = useState();
  const [showGoalModal, setShowGoalModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showViewChallenge, setShowViewChallenge] = useState(false);
  const [learnHistroyRes, setLearnHistoryRes] = useState();

  const subscribedCourses = JSON.parse(
    localStorage.getItem(COOKIE_ACCESS_SUBSCRIBED_COURSES) || "[]",
  );

  const learningChallengeHistroy = async () => {
    if (!mail) return;
    try {
      const res = await get(apiGetLearningChallenge(mail));
      if (res) {
        const history = res?.data?.history || [];
        const status =
          history[0]?.status === "INACTIVE" || history?.length === 0;
        // setLearningChallenge(res?.data?.history || []);

        // Check current course subscription
        const hasAccess = hasCourseAccess(
          subscribedCourses,
          examType, // or currentCourse
        );
        if (role !== "guest" && hasAccess && status) {
          setShowGoalModal(true);
        } else {
          setShowGoalModal(false);
        }
      }
    } catch (e) {
      console.log("ERROR COMES FROM LEARNING CHALLENGE HISTROY API", e);
      setShowGoalModal(false);
    }
  };

  const learningChallengeCreate = async (goalDays) => {
    console.log("goalDays:", goalDays);
    const payload = {
      email: mail,
      goal_period_days: parseInt(goalDays, 10),
    };

    try {
      const res = await post(API_LEARNING_CREATE, payload);
      if (res) {
        setLearningRes(res?.data?.data);
        setShowGoalModal(false);
        setShowSuccessModal(true);
      }
    } catch (e) {
      console.log("EEROR COMES FROM LEARNING CHALLENGE CREARE API", e);
    }
  };

  const getLearningHistroyDetails = async () => {
    if (role === "guest") return;
    if (!mail) return;
     const hasAccess = hasCourseAccess(
       subscribedCourses,
       examType, // or currentCourse
    );
    if(!hasAccess) return
    try {
      const res = await get(`/learning-challenge/status?email=${mail}`);
      if (res) {
        setLearnHistoryRes(res?.data?.data);
      }
    } catch (e) {
      console.log("ERROR COMES FROM LEARING HISTROY DETAILS API", e);
    }
  };

  useEffect(() => {
    learningChallengeHistroy();
  }, []);

  useEffect(() => {
    getLearningHistroyDetails();
  }, []);

  return {
    learningRes,
    showGoalModal,
    showSuccessModal,
    showViewChallenge,
    learnHistroyRes,
    setLearningRes,
    setShowGoalModal,
    setShowSuccessModal,
    setShowViewChallenge,
    learningChallengeCreate,
  };
};
